import WizardNavigation from './WizardNavigation';
export { WizardNavigation as default };
